"use client";

import { Menu } from "@base-ui/react/menu";
import { useState } from "react";
import DemoFooter from "@/components/preview/demo-footer";
import DemoWrapper from "@/components/preview/demo-wrapper";
import { Button } from "@/components/ui/button";
import { SpeedToggleButton } from "@/components/ui/speed-toggle-button";
import { cn } from "@/lib/utils";

const TRIGGERS = [
  {
    align: "start",
    className: "absolute top-3 left-3",
    label: "Top left",
    side: "bottom",
  },
  {
    align: "end",
    className: "absolute top-3 right-3",
    label: "Top right",
    side: "bottom",
  },
  { align: "center", className: "", label: "Center", side: "bottom" },
  {
    align: "start",
    className: "absolute bottom-3 left-3",
    label: "Bottom left",
    side: "top",
  },
  {
    align: "end",
    className: "absolute right-3 bottom-3",
    label: "Bottom right",
    side: "top",
  },
] as const;

const ITEMS = ["Open", "Duplicate", "Share", "Archive"];

export default function AnimationTransformOriginDemo() {
  const [slow, setSlow] = useState(false);

  return (
    <DemoWrapper margin="">
      <div className="relative flex h-72 w-full items-center justify-center">
        {TRIGGERS.map(({ align, className, label, side }) => (
          <Menu.Root key={label}>
            <Menu.Trigger
              render={
                <Button
                  className={className}
                  size="sm"
                  static
                  variant="secondary"
                />
              }
            >
              {label}
            </Menu.Trigger>
            <Menu.Portal>
              <Menu.Positioner
                align={align}
                className="z-50"
                side={side}
                sideOffset={4}
              >
                <Menu.Popup
                  className={cn(
                    "w-56 origin-(--transform-origin) rounded-xl bg-preview-bg p-1 text-gray-1200 shadow-custom outline-hidden transition-[transform,scale,opacity] ease-out will-change-transform motion-reduce:transition-none",
                    slow ? "duration-1000" : "duration-200",
                    slow
                      ? "data-ending-style:scale-50 data-starting-style:scale-50"
                      : "data-ending-style:scale-95 data-starting-style:scale-95",
                    "data-ending-style:opacity-0 data-starting-style:opacity-0"
                  )}
                >
                  {ITEMS.map((item) => (
                    <Menu.Item
                      className="relative flex cursor-pointer select-none items-center gap-2 rounded-lg px-2 py-1.5 text-sm outline-hidden hover-hover:hover:bg-gray-300 focus:bg-gray-300 focus:text-gray-1200"
                      key={item}
                    >
                      {item}
                    </Menu.Item>
                  ))}
                </Menu.Popup>
              </Menu.Positioner>
            </Menu.Portal>
          </Menu.Root>
        ))}
      </div>
      <DemoFooter>
        <SpeedToggleButton
          className="h-8 min-w-16 rounded-full"
          isFast={!slow}
          onToggle={() => setSlow(!slow)}
        />
      </DemoFooter>
    </DemoWrapper>
  );
}
